import React from "react";
import "./buttons.scss";
import { useTranslation } from 'react-i18next';
import { hasPermission } from "../../utils/permissionUtils";
import { PERMISSIONS } from "../../constants/permissions/Permissions";
import { Image_Url } from "../../constants/imageUrl/ImageUrl";

const Buttons = (props) => {
  const { t } = useTranslation();
  return (
    <div className="pgmlist_buttons_container">
      <div className="pgmlist_btns">
        {hasPermission(PERMISSIONS.CAN_VIEW_PGM_LIST) && (
          <>
            <button
              className={ props?.activeButton === "pending"
                ? "active Pgmlist_active_button"
                : "pgmlist_button"
              }
              onClick={() => props?.handlebuttonClick("pending")}
            >
              {t('pgmlist.buttons.pending')}
            </button>
            <button
              className={ props?.activeButton === "approved"
                ? "active Pgmlist_active_button"
                : "pgmlist_button"
              }
              onClick={() => props?.handlebuttonClick("approved")}
            >
              {t('pgmlist.buttons.approved')}
            </button>
            <button
              className={
                props?.activeButton === "draft"
                  ? "active Pgmlist_active_button"
                  : "pgmlist_button"
              }
              onClick={() => props?.handlebuttonClick("draft")}
            >
              {t('pgmlist.buttons.draft')}
            </button>
          </>
        )}
        {hasPermission(PERMISSIONS.CAN_CREATE_PGM_USER) && (
          <button
            className={
              window.location.pathname === "/partner" || props?.activeButton === "addNewPartner"
                ? "active Pgmlist_active_button"
                : "pgmlist_button"
            }
            onClick={() => props?.handleAddPartnerButtonClick("addNewPartner")}
          >
            {t('pgmlist.buttons.addNewPartner')}
          </button>
        )}
      </div>
      <div className="download-excel">
        <button className="dexcel partner-excel-download" onClick={() => props?.downloadPartnerExcel()}>
          <img src={Image_Url.DEXCEL} className="downloads_imgdexcel" />
          {t('pgmlist.downloadPartner')}
        </button>
      </div>
    </div>
  );
};

export default Buttons;
